import React from 'react';
import { Input } from '@/components/ui/input';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { SidebarTrigger, useSidebar } from '@/components/ui/sidebar';

import SEO from '@/components/SEO';

export default function Documentation() {
  const { isMobile } = useSidebar();

  return (
    <div className="flex flex-col flex-1 overflow-y-auto p-4 md:p-6 lg:p-8 bg-background text-foreground">
      <SEO title="Documentation - Ankh Studio" description="Official documentation sites" />
        <div className="flex justify-between items-center mb-4">
          <h1 className="text-2xl font-bold">Documentation</h1>
          {!isMobile && (
            <Input placeholder="Search documentation..." className="w-1/3" />
          )}
          {isMobile && <SidebarTrigger />}
        </div>

        <Card>
          <CardHeader>
            <CardTitle>Documentation</CardTitle>
            <CardDescription>Official documentation sites</CardDescription>
          </CardHeader>
          <CardContent>
            <p>List of documentation will be displayed here.</p>
          </CardContent>
        </Card>
    </div>
  );
}
